import "./ContactFormStyles.css";

import React, { useRef } from "react";
import emailjs from "emailjs-com";

const ContactForm = () => {
  const form = useRef();

  const sendEmail = (e) => {
    e.preventDefault();

    emailjs
      .sendForm(
        "service_mdt8oyo",
        "template_7y8oqgf",
        form.current,
        "d5vhX9qOxAILg2ag6"
      )
      .then(
        (result) => {
          console.log(result.text);
          alert("Message Sent!");
        },
        (error) => {
          console.log(error.text);
          alert("Message Failed to send!");
        }
      );
  };

  return (
    <div className="form">
      <form ref={form} onSubmit={sendEmail}>
        <label>Name</label>
        <input type="text" name="user_name" required></input>
        <label>Email</label>
        <input type="email" name="user_email" required></input>
        <label>Message</label>
        <textarea
          rows="6"
          placeholder="Please type your message."
          name="message"
          required
        />
        <input className="btn" type="submit" value="Send" />
      </form>
    </div>
  );
};

export default ContactForm;
